__webpack_require__.p = "https://robo-static-qa-obs.momenta.cn/rt-tos-fe/";